{
  "TermsAndConditions_Title": "Terms and Conditions",
  "TermsAndConditions_Subtitle": "The application terms and conditions of usage are shown below. Please indicate that you accept them by checking \"I agree to the terms of service.\" and also clicking the \"Accept\" button.",
  "TermsAndConditions_Subtitle_NoAccept": "Our standard terms of service are shown below.",
  "TermsAndConditions_AcceptText": "I agree to the terms and conditions",
  "TermsAndConditions_AcceptButton": "Accept",
  "TermsAndConditions_CloseButton": "Close",
  "NAME": "TermsAndConditions"
}